import { render, staticRenderFns } from "./Alpaclass.vue?vue&type=template&id=09541494&"
import script from "./Alpaclass.vue?vue&type=script&lang=js&"
export * from "./Alpaclass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports